import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PatientMapComponent } from './patient-map.component';

@NgModule({
  declarations: [
    PatientMapComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    PatientMapComponent
  ]
})
export class PatientMapModule { } 